<div class="btn-wrapper" [ngStyle]="{'margin-bottom': mb, 'margin-top': mt, minHeight}">
    <a class="text-btn" (click)="handleBtnClick()">
        {{text}}
    </a>
</div>